var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 3.29023C16.9604 3.54051 17.1591 3.83768 17.2946 4.16476C17.4302 4.49184 17.4999 4.84243 17.4999 5.19648C17.4999 5.55054 17.4302 5.90112 17.2946 6.2282C17.1591 6.55529 16.9604 6.85246 16.71 7.10273L15.3925 8.4169L11.5833 4.60773L12.9008 3.29023C13.4062 2.78547 14.0912 2.50195 14.8054 2.50195C15.5197 2.50195 16.2047 2.78547 16.71 3.29023ZM7.03167 16.7819L14.2142 9.59856L10.4017 5.78606L3.21833 12.9686L2.5 17.5002L7.03167 16.7819Z",
    fill: "#BA8D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlined);
export default __webpack_public_path__ + "static/media/edit-outlined.77381ecd4c40550a02864050a728710c.svg";
export { ForwardRef as ReactComponent };